"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybookCTAType = exports.PlaybookSortDirection = exports.PlaybookSortProperty = exports.PlaybookCategory = exports.PlaybookMetricType = exports.PlaybookMetricKey = exports.PlaybookPartType = void 0;
var PlaybookPartType;
(function (PlaybookPartType) {
  PlaybookPartType["INTERACTION"] = "INTERACTION";
  PlaybookPartType["WELCOME_MESSAGE"] = "WELCOME_MESSAGE";
  PlaybookPartType["SLIDER"] = "SLIDER";
  PlaybookPartType["TAKEOVER"] = "TAKEOVER";
  PlaybookPartType["AUTOMATIC_EMAIL"] = "AUTOMATIC_EMAIL";
  PlaybookPartType["ONE_TIME_EMAIL"] = "ONE_TIME_EMAIL";
  PlaybookPartType["EMAIL_CAPTURE"] = "EMAIL_CAPTURE";
  PlaybookPartType["ONE_TIME_OUTBOUND_EMAIL"] = "ONE_TIME_OUTBOUND_EMAIL";
  PlaybookPartType["OUTBOUND_SEQUENCE"] = "OUTBOUND_SEQUENCE";
  PlaybookPartType["MARKETING_SEQUENCE"] = "MARKETING_SEQUENCE";
  PlaybookPartType["SIGNATURE"] = "SIGNATURE";
  PlaybookPartType["LANDING_PAGE"] = "LANDING_PAGE";
  PlaybookPartType["PERSONAL_GREETING"] = "PERSONAL_GREETING";
})(PlaybookPartType = exports.PlaybookPartType || (exports.PlaybookPartType = {}));
var PlaybookMetricKey;
(function (PlaybookMetricKey) {
  PlaybookMetricKey["SENT"] = "SENT";
  PlaybookMetricKey["DELIVERED"] = "DELIVERED";
  PlaybookMetricKey["OPENED"] = "OPENED";
  PlaybookMetricKey["REPLIED"] = "REPLIED";
  PlaybookMetricKey["CLICKED"] = "CLICKED";
})(PlaybookMetricKey = exports.PlaybookMetricKey || (exports.PlaybookMetricKey = {}));
var PlaybookMetricType;
(function (PlaybookMetricType) {
  PlaybookMetricType["FIXED"] = "FIXED";
  PlaybookMetricType["CURRENCY"] = "CURRENCY";
  PlaybookMetricType["PERCENT"] = "PERCENT";
  PlaybookMetricType["DATETIME"] = "DATETIME";
  PlaybookMetricType["DATE"] = "DATE";
})(PlaybookMetricType = exports.PlaybookMetricType || (exports.PlaybookMetricType = {}));
var PlaybookCategory;
(function (PlaybookCategory) {
  PlaybookCategory["CHAT_ACTIVE"] = "CHAT_ACTIVE";
  PlaybookCategory["CHAT_ARCHIVED"] = "CHAT_ARCHIVED";
  PlaybookCategory["EMAIL_ACTIVE"] = "EMAIL_ACTIVE";
  PlaybookCategory["EMAIL_SCHEDULED"] = "EMAIL_SCHEDULED";
  PlaybookCategory["EMAIL_DRAFTS"] = "EMAIL_DRAFTS";
  PlaybookCategory["EMAIL_SENT"] = "EMAIL_SENT";
  PlaybookCategory["EMAIL_ARCHIVED"] = "EMAIL_ARCHIVED";
  PlaybookCategory["FAST_LANE_ACTIVE"] = "FAST_LANE_ACTIVE";
  PlaybookCategory["FAST_LANE_ARCHIVED"] = "FAST_LANE_ARCHIVED";
  PlaybookCategory["FAST_LANE_ALL"] = "FAST_LANE_ALL";
  PlaybookCategory["FASTLANE_ACTIVE"] = "FASTLANE_ACTIVE";
  PlaybookCategory["FASTLANE_ARCHIVED"] = "FASTLANE_ARCHIVED";
  PlaybookCategory["FASTLANE_ALL"] = "FASTLANE_ALL";
  PlaybookCategory["SEQUENCE_ACTIVE"] = "SEQUENCE_ACTIVE";
  PlaybookCategory["SEQUENCE_DRAFTS"] = "SEQUENCE_DRAFTS";
  PlaybookCategory["SEQUENCE_ARCHIVED"] = "SEQUENCE_ARCHIVED";
  PlaybookCategory["BOT_ACTIVE"] = "BOT_ACTIVE";
  PlaybookCategory["SIGNATURE_ACTIVE"] = "SIGNATURE_ACTIVE";
  PlaybookCategory["SIGNATURE_ARCHIVED"] = "SIGNATURE_ARCHIVED";
  PlaybookCategory["CHAT_ALL"] = "CHAT_ALL";
})(PlaybookCategory = exports.PlaybookCategory || (exports.PlaybookCategory = {}));
var PlaybookSortProperty;
(function (PlaybookSortProperty) {
  PlaybookSortProperty["priority"] = "priority";
  PlaybookSortProperty["name"] = "name";
  PlaybookSortProperty["last_updated"] = "last_updated";
  PlaybookSortProperty["last_created"] = "last_created"; // eslint-disable-line @typescript-eslint/camelcase
})(PlaybookSortProperty = exports.PlaybookSortProperty || (exports.PlaybookSortProperty = {}));
var PlaybookSortDirection;
(function (PlaybookSortDirection) {
  PlaybookSortDirection["asc"] = "asc";
  PlaybookSortDirection["desc"] = "desc";
})(PlaybookSortDirection = exports.PlaybookSortDirection || (exports.PlaybookSortDirection = {}));
var PlaybookCTAType;
(function (PlaybookCTAType) {
  PlaybookCTAType["CHAT_RESPONSE"] = "CHAT_RESPONSE";
  PlaybookCTAType["URL_LINK"] = "URL_LINK";
  PlaybookCTAType["SCHEDULE_MEETING"] = "SCHEDULE_MEETING";
})(PlaybookCTAType = exports.PlaybookCTAType || (exports.PlaybookCTAType = {}));